import UrineAnalysis from './UrineAnalysis';

export default UrineAnalysis;
